// extracted by mini-css-extract-plugin
module.exports = {"errorIndicator":"ErrorIndicator_errorIndicator__2oeP7","boom":"ErrorIndicator_boom__3sCPx"};